import React from 'react';
import Modal from '../../components/Modals/Modal.js';
import Table from '@mui/material/Table/Table';
import TableHead from '@mui/material/TableHead/TableHead';
import TableRow from '@mui/material/TableRow/TableRow';
import TableCell from '@mui/material/TableCell/TableCell';
import TableBody from '@mui/material/TableBody/TableBody';
import { helpers } from '@simplybenefits/sb-utils';
import { useTheme } from '@mui/material/styles';
import { fonts, globalStyles, colors } from '../../theme/index.js';
import * as dates from '@simplybenefits/sb-dates';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';

/**
 * 
 * @param {*} props 
 * @returns 
 */
const ClassAndDivisionDetailsModal = props => {
  const theme = useTheme();
  const styles = {
    table: globalStyles.table,
    tableHeading: {
      fontFamily: fonts.type.medium,
      color: "#FFFFFF",
      "&.MuiTableCell-root": {
        padding: "4px 30px"
      }
    },
    cell: {
      "&.MuiTableCell-root": {
        padding: "4px 30px"
      },
      color: colors.mainTextGrey
    },
    row: {
      "&.MuiTableRow-root": {
        '&:nth-of-type(odd)': {
          backgroundColor: theme.palette.whitelabel.buttonTextColor,
          "&:hover": {
            backgroundColor: colors.lightHoverGrey
          }
        },
        backgroundColor: colors.backgroundGrey,
        "&:hover": {
          backgroundColor: colors.lightHoverGrey
        }
      }
    },
    noPadding: {
      padding: 0,
      borderRadius: "0px"
    }
  };
  return /*#__PURE__*/React.createElement(Modal, {
    medium: true,
    open: props.showModal,
    onClose: props.hideModal,
    title: i18n.t(tokens.labels.admin.classAndDivisionDetails)
  }, /*#__PURE__*/React.createElement(Table, {
    padding: 0
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, {
    sx: {
      backgroundColor: theme.palette.primary.main,
      borderTop: "2px solid #FFFFFF"
    }
  }, /*#__PURE__*/React.createElement(TableCell, {
    padding: "none",
    sx: styles.tableHeading
  }, i18n.t(tokens.labels.classesAndDivisions.className)), /*#__PURE__*/React.createElement(TableCell, {
    padding: "none",
    sx: {
      ...styles.tableHeading,
      width: "35%"
    }
  }, i18n.t(tokens.labels.classesAndDivisions.classDescription)), /*#__PURE__*/React.createElement(TableCell, {
    padding: "none",
    sx: {
      ...styles.tableHeading,
      width: "35%"
    }
  }, i18n.t(tokens.labels.effectiveDate)))), /*#__PURE__*/React.createElement(TableBody, null, helpers.sortObjByTitle(props.classesData).map(classID => {
    const classData = props.classesData[classID];
    return /*#__PURE__*/React.createElement(TableRow, {
      key: classData.classID,
      hover: true,
      sx: styles.row
    }, /*#__PURE__*/React.createElement(TableCell, {
      padding: "none",
      sx: {
        border: "none",
        ...styles.cell
      }
    }, classData.title), /*#__PURE__*/React.createElement(TableCell, {
      padding: "none",
      sx: {
        border: "none",
        ...styles.cell,
        width: "35%"
      }
    }, classData.description), !classData.status ? /*#__PURE__*/React.createElement(TableCell, {
      padding: "none",
      sx: {
        border: "none",
        ...styles.cell,
        width: "35%",
        "&.MuiTableCell-root": {
          padding: "4px 30px 0px 70px"
        }
      }
    }, "-") : /*#__PURE__*/React.createElement(TableCell, {
      padding: "none",
      sx: {
        border: "none",
        ...styles.cell,
        width: "35%"
      }
    }, dates.getStartOfDay(classData.classEffectiveDate, "ll")));
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 32
    }
  }, /*#__PURE__*/React.createElement(Table, {
    padding: "none"
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, {
    sx: {
      backgroundColor: theme.palette.primary.main,
      borderTop: "2px solid #FFFFFF"
    }
  }, /*#__PURE__*/React.createElement(TableCell, {
    padding: "none",
    sx: styles.tableHeading
  }, i18n.t(tokens.labels.classesAndDivisions.divisionName)), /*#__PURE__*/React.createElement(TableCell, {
    padding: "none",
    sx: {
      ...styles.tableHeading,
      width: "35%"
    }
  }, i18n.t(tokens.labels.classesAndDivisions.divisionDescription)), /*#__PURE__*/React.createElement(TableCell, {
    padding: "none",
    sx: {
      ...styles.tableHeading,
      width: "35%"
    }
  }, i18n.t(tokens.labels.effectiveDate)))), /*#__PURE__*/React.createElement(TableBody, null, helpers.sortObjByTitle(props.divisions).map(divisionID => {
    const divisionData = props.divisions[divisionID];
    return /*#__PURE__*/React.createElement(TableRow, {
      key: divisionData.title,
      hover: true,
      sx: styles.row
    }, /*#__PURE__*/React.createElement(TableCell, {
      padding: "none",
      sx: {
        border: "none",
        ...styles.cell
      }
    }, divisionData.title), /*#__PURE__*/React.createElement(TableCell, {
      padding: "none",
      sx: {
        border: "none",
        ...styles.cell,
        width: "35%"
      }
    }, divisionData.description), divisionData.eligibilityOverrideDate || divisionData.accountEffectiveDate ? /*#__PURE__*/React.createElement(TableCell, {
      padding: "none",
      sx: {
        border: "none",
        ...styles.cell,
        width: "35%"
      }
    }, divisionData.eligibilityOverrideDate ? dates.getStartOfDay(divisionData.eligibilityOverrideDate, "ll") : dates.getStartOfDay(divisionData.accountEffectiveDate, "ll")) : /*#__PURE__*/React.createElement(TableCell, {
      padding: "none",
      sx: {
        border: "none",
        ...styles.cell,
        width: "35%",
        "&.MuiTableCell-root": {
          padding: "4px 30px 0px 70px"
        }
      }
    }, "-"));
  })))), /*#__PURE__*/React.createElement("span", {
    id: "classAndDivisionDetails"
  }));
};
export default ClassAndDivisionDetailsModal;